import { useMemo } from 'react';

import { keyBy } from 'lodash';

import { ClaimListPanelProps, ListItem } from './types';

import { ClaimItemBase } from '~/components/Claim/types';
import ExpandableListCard from '~/core/molecules/ExpandableListCard/ExpandableListCard';
import cn from '~/utils/cn';

const defaultCustomRender = (item: ClaimItemBase): ListItem => {
  return {
    id: item.id,
    content: (
      <div className="flex w-full items-center pr-8">
        <div>{item.title}</div>
      </div>
    ),
  };
};

const ClaimListPanel = <T extends ClaimItemBase>({
  title,
  items,
  maxVisibleItems,
  className,
  onItemClick,
  customRenderer = defaultCustomRender,
  emptyState,
  isLoading,
  errorMessage = '',
}: ClaimListPanelProps<T>) => {
  const itemsMap = useMemo<Record<string, T>>(() => keyBy(items, 'id'), [items]);
  const listItems = useMemo<ListItem[]>(() => {
    return items.map(customRenderer);
  }, [items, customRenderer]);

  const handleItemClick = (listItem: ListItem) => {
    if (onItemClick) {
      const originalItem = itemsMap[listItem.id];
      onItemClick?.(originalItem);
    }
  };

  return (
    <ExpandableListCard
      title={title}
      items={listItems}
      maxVisibleItems={maxVisibleItems}
      className={cn('rounded-xl border-gray-200 bg-white', className)}
      onItemClick={handleItemClick}
      emptyState={emptyState}
      isLoading={isLoading}
      isError={!!errorMessage}
    />
  );
};

export default ClaimListPanel;
